import React, { useState } from "react";
import Modal from "../CustomModal";
import AgentBusinessCardMini from "../AgentBusinessCardMini";
import "./styles.scss";
import Loading from "../Loading";
import successIcon from "../../images/success.svg";
import errorIcon from "../../images/error.svg";
import { useSelector } from "react-redux";

const ContactFormModal = ({ onSubmit, open, onClose, emailSentCookie }) => {
  const agentProfile = useSelector((store) => store.profile.agent);

  const [emailSent, setEmailSent] = useState(emailSentCookie);
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);

  let content = (
    <AgentBusinessCardMini
      withForm
      onCancelForm={onClose}
      onSubmitForm={(data) => {
        setLoading(true);
        onSubmit(data)
          .then(() => setEmailSent(true))
          .catch(() => setEmailError(true))
          .finally(() => setLoading(false));
      }}
    />
  );

  if (emailSent)
    content = (
      <div className="email-sent-message">
        <img src={successIcon} alt="success" />
        <p>
          {emailSentCookie
            ? "Your message has already been sent to the realtor for this property."
            : "Email successfully sent!"}
        </p>
        <p>
          <b>{agentProfile.FirstName}</b>{" "}
          {emailSentCookie
            ? "will follow up with you soon."
            : "will follow up with you shortly."}
        </p>
      </div>
    );
  if (emailError)
    content = (
      <div className="email-sent-message">
        <img src={errorIcon} alt="success" />
        <p>Error to send email!</p>
        <p>
          Please contact <b>{agentProfile.FirstName}</b> by other means.
        </p>
      </div>
    );
  if (loading) content = <Loading height="207px" />;

  return (
    <Modal
      modalIsOpen={open}
      handleClose={loading ? null : onClose}
      size="xs"
      className="dyna-modal no-gutters contact-modal"
      modalHeader={!loading && !emailSent && !emailError ? "Contact Agent" : ""}
      backdrop={loading ? "static" : true}
    >
      {content}
    </Modal>
  );
};

export default ContactFormModal;
